import { PatientState, PatientMutations, PatientActions, Patient } from '@/types'
import { PatientMutationType } from './mutation-types'
import { Payload } from 'vuex'
import api from '@/api'
import { PatientActionsType } from './action-types'

const state: PatientState = {
  errors: false,
  data: [],
  message: ''
}

const mutations: PatientMutations = {
  update (state, payload) {
    const { type, ...rest } = payload
    state = Object.assign(state, rest)
  },
  updateFromId (state, payload) {
    const { id, type, ...rest } = payload
    const index = state.data.findIndex(x => x.id === id)
    state.data[index] = Object.assign(state.data[index], rest)
  }
}

const actions: PatientActions = {
  async getPatients ({ commit, rootState }) {
    return api.patient.getPatients(rootState.auth)
      .then(resp => {
        commit({
          type: PatientMutationType.update,
          ...resp
        })
        return resp
      })
  },
  async newPatient ({ commit, rootState }, patient) {
    return api.patient.post(rootState.auth, patient)
      .then(resp => {
        commit({
          type: PatientMutationType.update,
          data: [...rootState.patient.data, resp.data]
        })
        return resp
      })
  },
  async updatePatient ({ commit, rootState }, payload) {
    const { id, ...rest } = payload
    return api.patient.patch(rootState.auth, rest, id)
      .then(resp => {
        commit({
          type: PatientMutationType.updateFromId,
          ...payload
        })
        return resp
      })
  },
  async deletePatient ({ dispatch, rootState }, id) {
    return api.patient.delete(rootState.auth, id)
      .then(resp => {
        dispatch(PatientActionsType.getPatients)
        return resp
      })
  }
}

export const patient = {
  state,
  mutations,
  actions
}
